module.exports = __webpack_public_path__ + "static/social-instagram-1e1ed2ea5a1c70fb2712a72576193b24.png";